import React, { Fragment, useContext } from 'react';

import { CompleteIdFlow } from './complete';
import { CountryAndDocument } from './countryAndDocument';
import { Onfido } from './onfido';
import { UploadIdStart } from './start';

import { StoreContext } from '../../App';

export const UploadId: React.FC = () => {
  const store = useContext(StoreContext);
  const { currentScreen } = store.AppState;

  return (
    <Fragment>
      {currentScreen.subpage === 1 && <UploadIdStart />}
      {currentScreen.subpage === 2 && <CountryAndDocument />}
      {currentScreen.subpage === 3 && <Onfido />}
      {currentScreen.subpage === 4 && <CompleteIdFlow />}
    </Fragment>
  );
};
